/*
 * Menu Landing
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import {
  MenuBar,
  LandingMenu,
  ClearLink,
  BarMenuItem,
  MobileNavBtn,
  icons,
} from '../LandingMenuBar';

import Logo from '../LogoLanding';
import Svg from '../Svg';

export class MenuLanding extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    let offset = 0;
    if (typeof window !== 'undefined') {
      offset = window.pageYOffset;
    }
    this.state = {
      isMenuOpened: false,
      isMenuMinified: false,
      offsetY: offset,
    };
    this.debounceListenToScroll = null;
  }

  componentDidMount() {
    this.debounceListenToScroll = debounce(this.listenToScroll, 100, { trailing: true });
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.debounceListenToScroll);
    }
  }

  componentDidUpdate(_, oldState) {
    const { offsetY } = this.state;
    const { offsetY: oldOffsetY } = oldState;

    if (oldOffsetY !== offsetY) {
      this.setState(({ isMenuMinified }) => {
        // se ho menù aperto e ho più di margin top 60
        if (isMenuMinified && offsetY < 60) {
          return { isMenuMinified: false };
          // menù chiuso e meno di scrolling 60
        }
        if (!isMenuMinified && offsetY >= 60) {
          return { isMenuMinified: true };
        }
        return null;
      });
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.debounceListenToScroll);
    }
  }

  listenToScroll = () => {
    if (typeof window !== 'undefined') {
      this.setState({ offsetY: window.pageYOffset });
    }
  };

  toggleMenu = (forceValue = null) => {
    this.setState(({ isMenuOpened }) => ({
      isMenuOpened: forceValue !== null ? forceValue : !isMenuOpened,
    }));
  };

  render() {
    const {
      color,
      activeColor,
      bgcolor,
      hoverBgcolor,
      bgStartColor,
      logo,
      navigation,
      title,
      goHomePageFunction,
    } = this.props;
    const { isMenuOpened, isMenuMinified } = this.state;
    const start = !isMenuMinified ? 1 : 0;
    const clickLogoFunction = isMenuOpened ? null : goHomePageFunction;

    return (
      <MenuBar
        bgcolor={bgcolor}
        bgStartColor={bgStartColor}
        start={start}
        openNav={isMenuOpened}
      >
        <LandingMenu className="LandingMenu" openNav={isMenuOpened}>
          <ClearLink onClick={clickLogoFunction}>
            <Logo
              logoImage={logo}
              start={start}
              title={title}
            />
          </ClearLink>
          <nav>
            {navigation.map(({
              id,
              onClickFunction,
              title: titleNavigation,
              href,
              externalUrl = false,
              activeLink = false,
            }) => (
              <BarMenuItem
                color={color}
                activeColor={activeColor}
                hoverBgcolor={hoverBgcolor}
                activeLink={activeLink}
                key={`menu_item_${id}`}
                href={href}
                onClick={() => {
                  if (onClickFunction) {
                    onClickFunction();
                  }
                  this.toggleMenu(false);
                }}
                target={externalUrl ? '_blank' : undefined}
                rel={externalUrl ? 'noopener noreferrer' : undefined}
              >
                {titleNavigation}
              </BarMenuItem>
            ))}
          </nav>
          <MobileNavBtn
            to="#"
            onClick={() => this.toggleMenu(!isMenuOpened)}
          >
            {isMenuOpened ? <Svg {...icons.close} /> : <Svg {...icons.hamburger} />}
          </MobileNavBtn>
        </LandingMenu>
      </MenuBar>
    );
  }
}

MenuLanding.propTypes = {
  goHomePageFunction: PropTypes.func,
  bgcolor: PropTypes.string,
  color: PropTypes.string,
  activeColor: PropTypes.string,
  hoverBgcolor: PropTypes.string,
  bgStartColor: PropTypes.string,
  logo: PropTypes.object,
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      onClickFunction: PropTypes.func,
      title: PropTypes.string.isRequired,
      href: PropTypes.string,
      externalUrl: PropTypes.bool,
      activeLink: PropTypes.bool,
    }),
  ).isRequired,
  title: PropTypes.string,
};

export default MenuLanding;
